import { getConfig } from '@edx/frontend-platform';
import { getLocale } from '@edx/frontend-platform/i18n';
import { logError } from '@edx/frontend-platform/logging';

import type { LearningPathConfigResponse, UserMetaDataResponse } from '../types';
import { apiRequest } from './utils/apiClient';

export const learningPathApi = {
  getLearningPathConfig: async (
    callback: (res: LearningPathConfigResponse) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/learning-path/config/`;

    try {
      const data = await apiRequest<LearningPathConfigResponse>({
        url,
        isAuth: false,
        method: 'GET',
      });

      callback(data);
    } catch (error) {
      logError('Error fetching learning path config', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },

  getPublicProfile: async (
    username: string,
    callback: (res: UserMetaDataResponse) => void,
    errorCallback?: (error: Error) => void,
  ): Promise<void> => {
    const url = `${getConfig().LMS_BASE_URL}/api/learning-path/v1/profiles/${username}/`;

    try {
      const data = await apiRequest<UserMetaDataResponse>({
        url,
        isAuth: false,
        method: 'GET',
        params: { lang: getLocale() },
      });

      callback(data);
    } catch (error) {
      logError('Error fetching public profile', error);
      if (errorCallback) {
        errorCallback(error as Error);
      }
    }
  },
};
